<div class="instances scrollable">
  <div class="accounts-header" translate="ACCOUNTS.CHOOSE"></div>
  <form [formGroup]="form">
    <input type="text" [placeholder]="'SEARCH' | translate" matInput formControlName="search">
  </form>

  <div class="avatars">
    <a *ngFor="let account of getFilteredAccounts" (click)="choose(account)" class="account-avatar">
      <span class="account-type" *ngIf="account.clientType.startsWith('SHOPER')">
        Shoper Connect
      </span>
      <cc-avatar avatarSize="account" [fullName]="account.name"></cc-avatar>
      <div class="account-name" [title]="account.name">{{account.name}}</div>
    </a>
  </div>
</div>
